module.exports = __webpack_public_path__ + "img/import-mobile-icon.47c8e29b.svg";